import { useTranslations } from "@ui/providers/useTranslations";
import classnames from "classnames";
import dompurify from "isomorphic-dompurify";

import { Button } from "@jti/core-components/components/Button";

import { QrCode } from "../QrCode";

import styles from "./QrAgeVerification.module.scss";

const { sanitize } = dompurify;

export type QrAgeVerificationProps = {
  verificationTitle: string;
  mobileQrHelper?: string;
  verificationSteps: string;
  isOverlay?: boolean;
  isLoading?: boolean;
  errorMessage?: string;
  getNewQrButtonLabel: string;
  qrCodeValue?: string;
  isPortable?: boolean;
  getNewCode: () => void;
};

export const QrAgeVerification: React.FC<QrAgeVerificationProps> = ({
  verificationTitle,
  mobileQrHelper,
  verificationSteps,
  errorMessage,
  getNewQrButtonLabel,
  isOverlay = false,
  isLoading = false,
  qrCodeValue,
  isPortable = false,
  getNewCode,
}) => {
  const handleQrClick = () => {
    window.open(qrCodeValue, "_blank");
  };

  const { __ } = useTranslations();

  return (
    <div
      className={classnames(styles.container, { [styles.containerOverlay]: isOverlay })}
      data-testid="qrAgeVerification"
    >
      <h3 className={styles.title}>{verificationTitle}</h3>

      <div className={styles.contentWrapper}>
        <div
          className={styles.steps}
          dangerouslySetInnerHTML={{
            __html: sanitize(verificationSteps),
          }}
        />

        <button
          data-testid="qrCodeLink"
          onClick={handleQrClick}
          className={styles.QrButton}
          disabled={!isPortable || !!errorMessage}
          aria-label={__("auth.age_verification.qr_code_link")}
        >
          <QrCode qrCodeValue={qrCodeValue ?? ""} isLoading={isLoading} errorMessage={errorMessage ?? ""} />
        </button>

        {isPortable && mobileQrHelper && !errorMessage && <p className={styles.helperText}>{mobileQrHelper}</p>}

        {errorMessage && !isLoading && (
          <div className={styles.newCodeButtonContainer}>
            <Button className={styles.newCodeButton} variant="text" data-testid="getNewQrCode" onClick={getNewCode}>
              {getNewQrButtonLabel}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
